const displayValue = (value, fallback = "N/A") =>
    value !== null && value !== undefined && value !== "" ? value : fallback;

export default displayValue;
